<template>
    <div>

        <a @click.prevent="editItem = true" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
            <!-- Heroicon name: pencil-alt -->
            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
            </svg>
            Edit
        </a>

        <div v-if="editItem" class="bg-blue-50 border-blue-400 rounded-lg my-4 pt-8 pb-5 px-5 relative">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="editItem = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between items-center mb-4  bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Edit Item</p>
                            <svg @click="editItem = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-5 pb-4 sm:p-6">
                            <form  @submit.prevent="submit">
                            <textarea v-model="item.message" ref="message" id="message" name="message" rows="10" class="mt-2 shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 font-mono sm:text-sm border-gray-300 rounded-md"></textarea>
                            <div class="flex justify-between items-center mt-6">
                            <div class="flex items-center">
                                <button @click="item.is_published = !item.is_published" type="button" aria-pressed="false" aria-labelledby="toggleLabel"
                                        :class="{ 'bg-blue-600' : item.is_published, 'bg-gray-200' : !item.is_published }"
                                        class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                    <span class="sr-only">Use setting</span>
                                    <span aria-hidden="true"
                                          :class="{ 'translate-x-5' : item.is_published, 'translate-x-0' : !item.is_published }"
                                          class="inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                </button>
                                <span class="ml-3" id="toggleLabel">
                                    <span class="text-sm font-medium text-gray-900">Published</span>
                                </span>
                            </div>

                            <loading-button :loading="saving"  type="submit" class="">
                                Save
                            </loading-button>
                        </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/Shared/LoadingButton";

export default {
    components: { LoadingButton },
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            saving: false,
            editItem: false,
        }
    },

    methods: {
        submit() {
            this.$inertia.put(this.route('settings.news.update', this.item.id), this.item, {
                onStart: () => this.saving = true,
                onFinish: () => this.saving = false,
                onSuccess: () => this.editItem = false,
            })
        }
    },
    watch: {
        editItem() {
            if (this.editItem) {
                this.$nextTick(() => {
                    this.$refs.message.focus()
                })
            } else {
                this.$emit('close-menu')
            }
        }
    }
}
</script>
